.banner-container {
  // We don't need this if applying to content-wrapper
  // position: sticky;
  // bottom: 0px;
}

.promo-content-wrapper {
  display: flex;
  transition: transform 0.5s ease-in-out;
  overflow: hidden; /* Ensure content does not slide past the container */
}

.banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 4px 15px 8px 15px;
  height: 135px;

  @media (min-width: "480px") {
    height: auto;
  }

  @media (min-width: map-get($grid-breakpoints, md)) {
    padding: 10px 37px;
    height: auto;
  }

  @media (min-width: map-get($grid-breakpoints, lg)) {
    padding: 10px 71px;
    height: auto;
  }

  @media (min-width: map-get($grid-breakpoints, xl)) {
    padding: 10px 135px;
    height: auto;
  }
  background-color: #d9f0f4;
}

.chevron {
  cursor: pointer;
  width: 15px;
  flex: none; /* Prevents the items from growing or shrinking */
  text-align: center;
  &:focus {
    outline: 1px solid black;
  }
}

.visible {
  visibility: visible;
}

.hidden {
  visibility: hidden;
  pointer-events: none;
}

.disabled-chevron {
  color: gray; /* Set the text color to gray */
  opacity: 0.6; /* Reduce the opacity */
  pointer-events: none; /* Disable pointer events */
  cursor: not-allowed; /* Change the cursor to indicate it's not clickable */
}

.promo-content-container {
  flex-grow: 1; /* Allows the item to grow */
  flex-shrink: 1; /* Allows the item to shrink if necessary */
  flex-basis: auto; /* Default size of the item */
  text-align: left; /* Centers the text within the item */
  padding: 0 0px; // TODO: make it 15 left/right when there is two or more offers
  @media (min-width: map-get($grid-breakpoints, md)) {
    text-align: center;
  }
  @media (min-width: map-get($grid-breakpoints, xl)) {
    // padding: 0 30px; // TODO: only 30px when more than one offer
  }
}

.tags {
  padding-right: 10px; /* default padding */
  // display: none;

  // @media (min-width: map-get($grid-breakpoints, sm)) {
  //   display: none;
  // }

  @media (min-width: map-get($grid-breakpoints, md)) {
    display: inline;
  }

  @media (min-width: map-get($grid-breakpoints, xl)) {
    display: inline;
  }
}

.tag {
  font-family: Averta-Regular, Arial, Helvetica, sans-serif;
  text-decoration: none;
  font-size: 12px;
  line-height: 15px !important;
  border-radius: 2px;
  padding: 0 3px;
  // margin-left: 5px;
  // margin-right: 4px;
}

.new-style {
  background-color: #147582;
  color: #fff;
}

.exclusive-style {
  background-color: transparent;
  color: $color-primary-grey;
  border: 1px solid black;
}

.phone-tag {
  /* shown when screen size is small, otherwise hide */
  @media (min-width: map-get($grid-breakpoints, md)) {
    display: none;
  }
  @media (max-width: map-get($container-max-widths, sm)) {
    display: block;
  }
  padding: 10px 30px 0 30px;
  background-color: #d9f0f4;
}

.promo-text {
  display: inline;
  text-align: center;
  font-family: "Averta-ExtraBold", sans-serif;
  font-size: 14px;
  color: $color-primary-grey;
  @media (min-width: map-get($grid-breakpoints, lg)) {
    font-size: 16px;
  }

  .promo-link {
    font-family: "Averta-Regular", sans-serif;
    font-size: 14px;
    @media (min-width: map-get($grid-breakpoints, lg)) {
      font-size: 16px;
    }
  }
  .text-vertical-bar {
    font-family: Averta-Regular, Arial, Helvetica, sans-serif;
    padding: 0 10px;

    @media (min-width: map-get($grid-breakpoints, lg)) {
      padding: 0 15px;
    }
  }
  .vertical-separator {
    font-family: Averta-Regular, Arial, Helvetica, sans-serif;
    position: relative;
    top: 5px;
    height: 18px; /* Adjust the height as needed */
    margin: 0 10px; /* Adjust spacing around the separator */
    @media (min-width: map-get($grid-breakpoints, lg)) {
      height: 20px;
      margin: 0 15px;
    }
    width: 0.5px; /* This controls the thickness of the separator */
    background-color: $color-primary-grey; /* This sets the color of the separator */
    display: inline-block; 
  }
}

.chevron-left {
  margin-right: 15px;

  @media (min-width: map-get($grid-breakpoints, lg)) {
    margin-right: 30px;
  }
}

.chevron-right {
  margin-left: 15px;

  @media (min-width: map-get($grid-breakpoints, lg)) {
    margin-left: 30px;
  }
}

.tag-with-chevron {
  margin-left: 15px;
}


// Animation stuff //

@keyframes slideInFromRight {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slideOutToLeft {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

@keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}

@keyframes slideOutToRight {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}

.slide-in-from-right {
  animation: slideInFromRight 0.5s forwards;
}

.slide-out-to-left {
  animation: slideOutToLeft 0.5s forwards;
}

.slide-in-from-left {
  animation: slideInFromLeft 0.5s forwards;
}

.slide-out-to-right {
  animation: slideOutToRight 0.5s forwards;
}
